export enum BILL_TYPE {
	OTHER = 'OTHER',
	EK = 'EK',

	FIRST = 'FIRST',
	SECOND = 'SECOND',
	THIRD = 'THIRD',
}
